const storageKey = 'inspirationAdviceFilter';

export const saveFiltersInSessionStorage = (filterTags: Record<string, string>) =>
  typeof window !== 'undefined' && window.sessionStorage.setItem(storageKey, JSON.stringify(filterTags));

export const getFiltersFromSessionStorage = (keyName?: string) => {
  if (typeof window === 'undefined') return;

  const filters = JSON.parse(window.sessionStorage.getItem(storageKey) ?? '{}');

  return keyName ? filters[keyName] : filters;
};
